<template>
  <div class="paperEdit-dialog">
    <!-- 试题排序弹窗 -->
    <el-dialog
      title="试题排序"
      :visible="sort"
      :close-on-click-modal="false"
      width="700px"
      center
      custom-class="dialog-commoon-style"
      @close="closeDialog('sort', false)"
    >
      <div class="exercise-type-wrap">
        <p v-for="item in sortExerciseData" :key="item.id">
          <span :title="item.type_name">{{ item.type_name }}：</span>
          <el-radio-group v-model="item.sort_order">
            <el-radio :label="2">难度从低到高</el-radio>
            <el-radio :label="1">难度从高到低</el-radio>
          </el-radio-group>
        </p>
      </div>
      <span slot="footer">
        <el-button type="primary" size="small" @click="sortConfirm">确 定</el-button>
        <el-button size="small" @click="closeDialog('sort', false)">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 得分设置弹窗 -->
    <el-dialog
      title="设置得分"
      :visible="scoreSet"
      :close-on-click-modal="false"
      width="700px"
      center
      custom-class="dialog-commoon-style score-setting-dialog"
      @close="closeDialog('scoreSet', false)"
    >
      <div class="score-setting-item" v-for="(item, index) in scoreSetData" :key="item.id">
        <div class="score-setting-header">
          <div class="score-header-title">
            {{ item.type_name }}
            <span v-if="item.score > 0">(共{{ item.score }}分)</span>
          </div>
          <div class="score-header-avreage">
            <el-input
              size="mini"
              v-model="item.average"
              :maxlength="4"
              @input="avergageScore(item, index)"
              @keyup.native="formatValue(item, item.average)"
            ></el-input>
            <span>分/题</span>
          </div>
        </div>
        <ul class="score-setting-body">
          <li class="score-setting-body-item" v-for="(row, index2) in item.question" :key="row.id">
            <span>
              <span v-html="row.title_text"></span>
            </span>
            <span>{{ row.difficulty }}</span>
            <span>
              <el-input
                size="mini"
                v-model="row.score"
                @input="calcTotalScore(item, index, index2)"
                @keyup.native="formatValue(row, row.score)"
              ></el-input>
              分
            </span>
          </li>
        </ul>
      </div>
      <span slot="footer">
        <el-button type="primary" size="small" @click="scoreSetConfirm">确 定</el-button>
        <el-button size="small" @click="closeDialog('scoreSet', false)">取 消</el-button>
        <span class="score-setting-total"
          >总分:<strong>{{ allScoreTotal }}</strong
          >分</span
        >
      </span>
    </el-dialog>

    <!-- 试题统计弹窗 -->
    <el-dialog
      title="试卷分析"
      :visible="scoreCount"
      :close-on-click-modal="false"
      width="900px"
      custom-class="dialog-commoon-style score-count-dialog"
      @close="scoreCount = false"
    >
      <div class="score-count-item">
        <p>难度统计</p>
        <div class="score-count-table">
          <div class="score-count-table-header score-count-diff-header">
            <span>容易</span>
            <span>较易</span>
            <span>普通</span>
            <span>较难</span>
            <span>困难</span>
          </div>
          <ul class="score-count-table-body">
            <li class="score-count-table-diffl-li">
              <span v-for="item in scoreCountDiffData" :key="item.index">{{ item.prop }}%</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="score-count-item">
        <p>题型统计</p>
        <div class="score-count-table">
          <div class="score-count-table-header">
            <span>题型</span>
            <span>题量 <i>/</i> 占比</span>
            <span>分值 <i>/</i> 占比</span>
          </div>
          <ul class="score-count-table-body">
            <li v-for="item in scoreCountExerciseData" :key="item.index">
              <span>{{ item.name }}</span>
              <span>{{ item.question_num }} <i>/</i> {{ item.num_prop }}%</span>
              <span>{{ item.score }} <i>/</i> {{ item.score_prop }}%</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="score-count-item">
        <p>知识点统计</p>
        <div class="score-count-table">
          <div class="score-count-table-header">
            <span>知识点</span>
            <span>题量 <i>/</i> 占比</span>
            <span>分值 <i>/</i> 占比</span>
          </div>
          <ul class="score-count-table-body">
            <li v-for="item in knolegeCountData" :key="item.index">
              <span>{{ item.name }}</span>
              <span>{{ item.num }} <i>/</i> {{ item.num_prop }}%</span>
              <span>{{ item.score }} <i>/</i> {{ item.score_prop }}%</span>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>

    <!-- dialog删除弹窗 -->
    <el-dialog
      :visible="deleteExercise"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="400px"
      :lock-scroll="true"
      center
      class="shopping-cart-overNum-dialog"
      @close="closeDialog('deleteExercise', false)"
    >
      <p><i class="iconfont icon-tixing2"></i></p>
      <p>确定要删除该试题吗？</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="comfirmDelete">确 定</el-button>
        <el-button @click="closeDialog('deleteExercise', false)">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 普通用户弹窗 -->
    <el-dialog
      :visible="is_general"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="400px"
      :lock-scroll="true"
      center
      class="general-dialog"
      @close="is_general = false"
    >
      <div class="dialog-body">
        <img src="../assets/images/tixing.png" alt="" />
        <h5>试卷分析仅组卷VIP用户可用</h5>
        <p>开通组卷VIP，300万精选试题解析任意看，还享7折组卷优惠，10大VIP特权</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="realizeVIP">了解组卷VIP</el-button>
      </span>
    </el-dialog>
    

    <!-- 点击完成组卷按钮弹窗 -->
    <el-dialog
      :title="finishedTitle"
      :close-on-click-modal="false"
      :visible="finished"
      v-if="finished"
      width="520px"
      @close="finished = false"
      center
      custom-class="dialog-commoon-style download-dialog"
    >
      <p v-if="finishedFlag != 3" class="ting-xing-icon">
        <img src="../assets/images/tixing.png" alt="" />
      </p>
      <p class="no-set-score" v-if="finishedFlag == 1">
        当前试卷未设置得分，是否完成组卷？
      </p>
      <p class="no-set-score" v-if="finishedFlag == 2">试卷得分为 {{ allScoreTotal }} 分，是否完成组卷？</p>
      <div class="finished-info" v-if="finishedFlag == 3">
        <p class="paper-title">试卷标题：</p>
        <el-input v-model="title" size="medium" class="paper-input" :maxlength="60" @blur="!title ? (title = ctitle) : ''"></el-input>
        <div class="nice-tips"><i class="el-icon-info"></i>温馨提示：</div>
        <p class="paper-tips">• 完成组卷后，试题、试题顺序、试题分值及试卷结构将无法修改</p>
        <p class="paper-tips">
          • 已完成的组卷可在 <a :href="`${baseLink}user/home`" target="_blank" class="link">“个人中心”</a> -
          <a :href="`${baseLink}user/paper_packages`" class="link" target="_blank">“我的组卷”</a> 中查看
        </p>
      </div>
      <div slot="footer">
        <div v-if="finishedFlag == 3">
          <el-button size="small" type="primary" @click="submitFinishedPaper">完成</el-button>
          <el-button size="small" @click="finished = false">取消</el-button>
        </div>
        <div v-else>
          <el-button size="small" type="primary" @click="setScore">设置得分</el-button>
          <el-button size="small" @click="showPaperInfo">完成组卷</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
var that
var timer = null
import {
  paperSorts,
  paperScore,
  paperStatisticals,
  completePaper,
} from '@/api/paperEdit'
import { removePaperExercise } from '@/api/manual.js'
import { mapGetters } from 'vuex'
import * as util from '../utils/util.js'
import validate from '../utils/validate.js'
export default {
  name: 'paperEditDialog',
  props: ['paperId', 'sort', 'sortExerciseData', 'scoreSet', 'scoreSetData', 'deleteExercise', 'questionListData', 'question_id', 'paperTitle'],
  data() {
    return {
      scoreCountDiffData: [],
      knolegeCountData: [],
      scoreCountExerciseData: [],
      allScoreTotal: 0,
      download: false,
      downloadTitle: '提醒',
      showFlag: 0,
      paperDownloadInfo: '',
      paperRechargeInfo: '',
      finishedTitle: '提醒',
      finished: false,
      finishedFlag: 0,
      title: '',
      ctitle: '',
      scoreCount: false,
      is_general: false,
    }
  },
  created() {
    that = this
  },
  computed: {
    ...mapGetters(['baseLink']),
  },
  watch: {
    balanceNotEnough(val) {
      if (val) {
        timer = window.setInterval(() => {
          that.checkOrderStatus(that.paperRechargeInfo.order)
        }, 3000)
      } else {
        window.clearInterval(timer)
      }
    },
    paperTitle(newVal) {
      that.title = newVal
      that.ctitle = newVal
    },
  },
  methods: {
    closeDialog(str, status) {
      that.$emit(`update:${str}`, status)
    },
    async sortConfirm() {
      let sort = []
      that.sortExerciseData.forEach(item => {
        let obj = {}
        obj.id = item.id
        obj.rule = Number(item.sort_order)
        sort.push(obj)
      })
      let data = {
        paper_id: that.paperId,
        sort: sort,
      }
      let res = await paperSorts(data)
      if (res.code == 200) {
        that.closeDialog('sort', false)
        that.$emit('reloadPaper', true)
      }
    },
    calcAllExerciseScore() {
      // 统计总得分
      let total = 0
      that.scoreSetData.forEach(item => {
        total += item.score
      })
      that.allScoreTotal = total
    },
    formatValue(obj, value, flag) {
      var str = value,
        len1 = str.substr(0, 1),
        len2 = str.substr(1, 1)
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != '.') {
        str = str.substr(1, 1)
      }
      //第一位不能是.
      if (len1 == '.') {
        str = ''
      }
      //限制只能输入一个小数点
      if (str.indexOf('.') > -1) {
        var str_ = str.substr(str.indexOf('.') + 1)
        //限制只能输入一个小数点
        if (str_.indexOf('.') != -1) {
          str = str.substr(0, str.indexOf('.') + str_.indexOf('.') + 1)
        }
      }
      str = str.substr(0, 4)
      if (flag) {
        // 直接返回值
        return str
      } else {
        if (obj.average) {
          that.$set(obj, 'average', str)
        } else if (obj.score) {
          that.$set(obj, 'score', str)
        }
      }
    },
    avergageScore(row, index) {
      if (!validate.isNumAndPoint(row.average.substr(0, 1))) {
        row.average = ''
        return
      }
      // 平分分数
      let point = 0
      that.scoreSetData[index].question.forEach(item => {
        let num = that.formatValue(that.scoreSetData[index], that.scoreSetData[index].average, true)
        let len = num.substr(num.length - 1, 1)
        if (len == '.') {
          num = num.substring(0, num.length - 1)
        }
        that.$set(item, 'score', num)
        point += Number(item.score)
      })
      that.$set(that.scoreSetData[index], 'score', point)
      that.calcAllExerciseScore()
      setTimeout(() => {
        that.scoreSetData[index].average = '' // 延迟清空
      }, 2000)
    },
    calcTotalScore(row, index, index2) {
      // 联动总分
      let total = 0
      that.scoreSetData[index].question.forEach(item => {
        if (item.score.length > 4) {
          item.score = item.score.substr(0, 4) // 最多四位
        }
        total += Number(item.score)
      })
      that.$set(that.scoreSetData[index], 'score', total)
      that.calcAllExerciseScore()
    },
    async setPaperScore() {
      // 设置得分
      let question = []
      that.scoreSetData.forEach(item => {
        item.question.forEach(item1 => {
          let obj = {}
          obj.id = item1.question_id
          obj.score = Number(item1.score)
          obj.type_id = Number(item.type_id)
          question.push(obj)
        })
      })
      let data = {
        paper_id: that.paperId,
        question: question,
      }
      let res = await paperScore(data)
      if (res.code == 200) {
        that.$emit('reloadPaper', true)
        that.closeDialog('scoreSet', false)
      }
    },
    scoreSetConfirm() {
      // 确定得分设置弹窗
      if (that.allScoreTotal % 10 == 0) {
        // 是否是10的倍数
        // 提交接口
        that.setPaperScore()
      } else {
        const h = that.$createElement
        this.$confirm('', '温馨提示', {
          cancelButtonText: '修改得分',
          confirmButtonText: '确定',
          type: 'warning',
          message: h('p', null, [
            h('span', null, '试卷总分为'),
            h(
              'strong',
              {
                style: 'color: red;padding:0 5px',
              },
              that.allScoreTotal
            ),
            h('span', null, '分，是否确定？'),
          ]),
        })
          .then(() => {
            // 提交接口
            that.setPaperScore()
          })
          .catch(() => {})
      }
    },
    async getPaperStatisticals() {
      // 试卷统计
      let data = {
        paper_id: that.paperId,
      };
      return new Promise((resolve, reject) => {
        paperStatisticals(data).then(res => {
              if (res.code === 200) {
              this.scoreCount = true
              res.data.diff.forEach(item => {
                if (item.name == '容易') {
                  that.scoreCountDiffData[0] = item
                } else if (item.name == '较易') {
                  that.scoreCountDiffData[1] = item
                } else if (item.name == '普通') {
                  that.scoreCountDiffData[2] = item
                } else if (item.name == '较难') {
                  that.scoreCountDiffData[3] = item
                } else if (item.name == '困难') {
                  that.scoreCountDiffData[4] = item
                }
              })
              that.knolegeCountData = res.data.knowledge
              that.scoreCountExerciseData = res.data.type
            }
        }).catch(err => {
          if (err.code === 407) {
            this.is_general = true
          }
        })
      })
    },
    async comfirmDelete() {
      // 删除试题
      if (that.questionListData.length == 1 && that.questionListData[0].question.length == 1) {
        util.showTips('试卷的试题不能为空')
      } else {
        let data = {
          type: 3,
          paper_id: that.paperId,
          question_id: that.question_id,
        }
        let res = await removePaperExercise(data)
        if (res.code === 200) {
          let curIndex = ''
          that.questionListData.forEach((item, index) => {
            item.question.forEach((item1, i) => {
              if (item1.question_id == that.question_id) {
                curIndex = item1.sort
                item.question.splice(i, 1) // 删除当前试题
                // if(item.question.length == 0) { // 当question数组为空时，删除该题类
                //   that.questionListData.splice(index,1);
                // }
              }
            })
          })
          that.questionListData.forEach((row, index) => {
            // 调整排序
            that.$set(row, 'index', util.numToChinese(index + 1)) // 大题类别顺序
            row.question.forEach((row1, i) => {
              if (row1.sort > curIndex) {
                that.$set(row1, 'sort', row1.sort - 1)
              }
            })
          })
          that.closeDialog('deleteExercise', false)
          that.$emit('reloadPaper', true)
        }
      }
    },
    setScore() {
      // 下载弹窗跳到设置得分弹窗
      that.finished = false
      that.closeDialog('scoreSet', true)
      that.calcAllExerciseScore()
    },
    showPaperInfo() {
      that.finishedFlag = 3
      that.finishedTitle = '完成组卷'
      that.finished = true
    },
    showDiffdialog(temp) {
      if (temp == '3') {
        that.showPaperInfo()
      } else {
        if (that.allScoreTotal <= 0) {
          // 未设置得分
          that.finishedFlag = 1
          that.finishedTitle = '提醒'
          that.finished = true
        }
        if (that.allScoreTotal > 0 && that.allScoreTotal % 10 != 0) {
          // 得分异常
          that.finishedFlag = 2
          that.finishedTitle = '提醒'
          that.finished = true
        }
        if (that.allScoreTotal > 0 && that.allScoreTotal % 10 == 0) {
          that.showPaperInfo()
        }
      }
    },
    submitFinishedPaper() {
      // 确定完成组卷
      return new Promise((resolve, reject) => {
        completePaper(that.paperId, that.title).then(res => {
          if (res.code == 200) {
            window.open(`${that.baseLink}paper-${that.paperId}.html`, '_self')
          }
        })
      })
    },
    realizeVIP(){
      this.is_general = false
      window.open(`${this.baseLink}vip`)
    }
  },
}
</script>
<style lang="scss" scoped>
.exercise-type-wrap {
  width: 100%;
  & > p {
    margin: 5px 0 15px;
    text-align: center;
    line-height: 20px;
    & > span {
      display: inline-block;
      width: 100px;
      font-size: 14px;
      color: #666;
      padding: 0 5px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      vertical-align: middle;
    }
    & > .el-radio-group > .el-radio {
      color: #333;
      font-size: 14px;
    }
  }
}
.score-setting-dialog {
  width: 100%;
  .score-setting-item {
    width: 100%;
    overflow: hidden;
    border: 1px solid #f2f2f2;
    & > .score-setting-header {
      box-sizing: border-box;
      width: 100%;
      height: 40px;
      line-height: 40px;
      padding: 0 10px;
      overflow: hidden;
      background-color: #f2f2f2;
      & > .score-header-title {
        float: left;
        color: #333;
        font-size: 14px;
        & > span {
          margin-left: 5px;
        }
      }
      & > .score-header-avreage {
        float: right;
        color: #666;
        font-size: 14px;
        text-align: right;

        & > .el-input {
          width: 50px;
          margin-right: 3px;
        }
      }
    }
    .score-setting-body {
      width: 100%;
      overflow: hidden;
      min-height: 10px;
      .score-setting-body-item {
        box-sizing: border-box;
        padding: 0 10px;
        height: 52px;
        line-height: 52px;
        border-bottom: 1px solid #f2f2f2;
        &:last-child {
          border-bottom: none;
        }
        span {
          float: left;
          height: 100%;
          font-size: 14px;
        }
        & > span:nth-child(1) {
          width: 425px;
          color: #333;

          & > span {
            display: inline-block;
            width: 90%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        & > span:nth-child(2) {
          width: 85px;
          text-align: center;
          color: #999;
          border-left: 1px solid #f2f2f2;
          border-right: 1px solid #f2f2f2;
        }
        & > span:nth-child(3) {
          width: 110px;
          text-align: right;
          color: #666;

          & > .el-input {
            width: 50px;
          }
        }
      }
    }
  }
  .score-setting-total {
    position: absolute;
    right: 20px;
    line-height: 34px;
    font-size: 14px;
    color: #666;

    & > strong {
      color: red;
      padding: 0 8px;
    }
  }
}
.score-count-dialog {
  width: 100%;
  .score-count-item {
    width: 100%;
    margin-bottom: 20px;
    & > p {
      font-size: 14px;
      color: #333;
      margin-bottom: 8px;
    }

    & > .score-count-table {
      width: 100%;
      text-align: center;
      border: 1px solid #f2f2f2;

      & > .score-count-table-header {
        width: 100%;
        height: 30px;
        line-height: 30px;
        background-color: #f2f2f2;

        & > span {
          float: left;
          width: 33%;
          height: 100%;
          line-height: 30px;
          color: #666;

          & > i {
            color: #ccc;
          }
        }

        &.score-count-diff-header {
          & > span {
            width: 20%;
          }
        }
      }

      & > .score-count-table-body {
        width: 100%;
        overflow: hidden;

        & > li {
          width: 100%;
          border-bottom: 1px solid #f2f2f2;
          overflow: hidden;

          & > span {
            box-sizing: border-box;
            float: left;
            width: 33.33333%;
            height: 100%;
            line-height: 32px;
            color: #333;

            & > i {
              color: #ccc;
            }

            &:nth-child(2) {
              border-left: 1px solid #f2f2f2;
              border-right: 1px solid #f2f2f2;
            }
          }

          &.score-count-table-diffl-li {
            & > span {
              width: 20%;
            }
          }

          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
}
.shopping-cart-overNum-dialog {
  .el-dialog__header {
    padding: 0;
  }

  p:nth-child(1) {
    color: #f60;
    font-size: 40px;
    text-align: center;
  }

  p:nth-child(2) {
    font-size: 16px;
    color: #333;
    text-align: center;
    margin-top: 12px;
    line-height: 24px;
  }
}
.general-dialog .dialog-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  img {
    width: 46px;
  }
  h5 {
    color: #333333;
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0;
  }
  p{
    width: 260px;
    color: #999;
    line-height: 20px;
  }
}
.download-dialog {
  .ting-xing-icon {
    margin-top: 30px;
    text-align: center;
  }
  .no-set-score {
    text-align: center;
    font-size: 16px;
    padding: 30px 0 50px;
  }
  .noraml-download {
    padding: 20px 0 50px;
    text-align: center;
    min-height: 70px;
    & > p {
      line-height: 28px;
      &:nth-child(2) {
        color: #999;
      }
      & > span {
        color: red;
      }
    }
    .down-free {
      color: #000;
      span {
        color: #3aa60d;
      }
    }
    p.acitve-tips {
      color: #f60;
    }
  }
  .finished-info {
    width: 100%;
    .paper-title {
      margin-bottom: 10px;
      color: #666;
      font-size: 14px;
      line-height: 16px;
    }
    .nice-tips {
      color: #f60;
      margin: 15px 0 10px 0;
      & > i {
        margin-right: 5px;
      }
    }
    .paper-tips {
      margin-top: 10px;
      color: #999;
      font-size: 14px;
      .link {
        color: #2b99ff;
      }
    }
  }
}
.icon-tixing2 {
  font-size: 40px;
}
</style>
